<template>
 <div class="detection-dialog">
	<el-dialog width="80%" :title="dialogTitle" :visible.sync="showDialog" :before-close="close" :close-on-click-modal="false">
		<checkbox-detection-list v-if="buildBase" ref="checkboxList" @getSelected='getSelected' :otherColumn="false" :selected="selectedDetection" :category="category" :seeDetection="seeDetection"></checkbox-detection-list>
    <no-config-detection-list :basePackageId="basePackageId" v-else ref="checkboxList" @getSelected='getSelected' :otherColumn="false" :selected="selectedDetection" :category="category" :seeDetection="seeDetection"></no-config-detection-list>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="certain">确 定</el-button>
    </span>
	</el-dialog>
 </div>
</template>

<script>
import checkboxDetectionList from 'cps/gene-product/selector/checkbox-detection-list'
import noConfigDetectionList from 'cps/gene-product/selector/no-config-detection-list'
export default {
  name: 'package-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dialogTitle: {
      type: String,
      default: ''
    },
    detectionSelected: {
      type: Array,
      default: function () {
        return []
      }
    },
    // 是否是编辑检测项
    isEdit: {
      type: Boolean,
      default: false
    },
    // 传入的所属分类
    category: {
      type: String,
      default: ''
    },
    seeDetection: {
      type: Object,
      default: () => {}
    },
    buildBase: {
      type: Boolean,
      default: true
    },
    basePackageId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      selectedDetection: this.detectionSelected,
      detectionIsEdit: this.isEdit,
      addSelected: []
    }
  },
  components: {
    checkboxDetectionList,
    noConfigDetectionList
  },
  computed: {
    showDialog () {
      return this.dialogVisible
    }
  },
  watch: {
    'detectionSelected': {
      handler: function (newVal) {
        this.selectedDetection = newVal
      },
      deep: true
    },
    isEdit (val) {
      this.detectionIsEdit = val
    }
  },
  methods: {
    close () {
      // if (this.buildBase) {
      this.selectedDetection = []
      // }

      this.$emit('updateDetection', false)
    },
    certain () {
      if (this.detectionIsEdit) {
        let copy = JSON.parse(JSON.stringify(this.addSelected))
        this.$emit('editDetection', copy)
      } else {
        console.log('-------------------this.addSelected', this.addSelected)
        this.$emit('addDetection', this.addSelected)
      }
      this.close()
    },
    // 获取从子组件勾选的值
    getSelected (val) {
      this.addSelected = val
    }
  }
}
</script>

<style lang="less">
.detection-dialog{
  .el-dialog{
    min-width: 600px;
    overflow-y: auto;
  }
}
</style>
